import { render, staticRenderFns } from "./Indywidualni.vue?vue&type=template&id=adc0603e"
import script from "./Indywidualni.vue?vue&type=script&lang=js"
export * from "./Indywidualni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports